import { h } from "@stencil/core";
import { liveKitCallbacks } from "./callbacks";
import { renderShowcaseProperties, updateShowcase } from "../utils";
const state = {};
const handleConnect = () => {
    if (state.url !== "" && state.token !== "") {
        state.connected = true;
        updateShowcase();
    }
};
const handleDisconnect = () => {
    state.connected = false;
    updateShowcase();
};
const handleMute = () => {
    state.microphoneEnabled = false;
    updateShowcase();
};
const handleUnmute = () => {
    state.microphoneEnabled = true;
    updateShowcase();
};
const render = () => (h("div", { class: "tab-test-main-wrapper" }, h("ch-live-kit-room", { callbacks: liveKitCallbacks, connected: state.connected, microphoneEnabled: state.microphoneEnabled, url: state.url, token: state.token }, h("div", { class: "button-container", part: "button-container" }, state.connected && state.microphoneEnabled && (h("button", { class: "button-primary", onClick: handleMute }, "Mute")), state.connected && !state.microphoneEnabled && (h("button", { class: "button-primary", onClick: handleUnmute }, "Unmute")), state.connected && (h("button", { class: "button-primary", onClick: handleDisconnect }, "Disconnect")), !state.connected && (h("button", { class: "button-primary", onClick: handleConnect }, "Connect"))))));
const showcaseRenderProperties = [
    {
        caption: "Properties",
        properties: [
            {
                id: "url",
                caption: "Url",
                value: "",
                render: "input",
                type: "string"
            },
            {
                id: "token",
                caption: "Token",
                value: "",
                render: "input",
                type: "string"
            },
            {
                id: "connected",
                caption: "Connected",
                value: false,
                render: "checkbox",
                type: "boolean"
            },
            {
                id: "microphoneEnabled",
                caption: "Microphone Enabled",
                value: false,
                render: "checkbox",
                type: "boolean"
            }
        ]
    }
];
const showcasePropertiesInfo = [
    { name: "url", fixed: true, value: "", type: "string" },
    { name: "token", fixed: true, value: "", type: "string" },
    { name: "connected", defaultValue: false, type: "boolean" },
    {
        name: "microphoneEnabled",
        defaultValue: true,
        type: "boolean"
    }
];
export const liveKitRoomShowcaseStory = {
    properties: showcaseRenderProperties,
    markupWithoutUIModel: {
        react: () => `<ChLiveKitRoom${renderShowcaseProperties(state, "react", showcasePropertiesInfo)}
          ></ChLiveKitRoom>`,
        stencil: () => `<ch-live-kit-room${renderShowcaseProperties(state, "stencil", showcasePropertiesInfo)}
            ></ch-live-kit-room>`
    },
    render: render,
    state: state
};
